/**
 * Backups und Sicherungsstände (§28).
 *
 * **Es gibt keine Datenbanktabelle für Backups** (Entscheidung E25 in `docs/ARCHITECTURE.md`).
 * Eine Wiederherstellung ersetzt den Datenbestand; ein in der Datenbank geführtes Verzeichnis
 * würde dabei durch den älteren Stand aus dem Backup überschrieben, während die Dateien auf der
 * Platte die neuere Wahrheit sind. Die Liste entsteht deshalb aus dem Backupverzeichnis, die
 * Angaben je Datei aus deren eigenem Kopf.
 */
/** Art eines Backups. Bestimmt zugleich, woher der Schlüssel stammt. */
export const BACKUPART_WERTE = ['manuell', 'sicherungsstand'];
export const BACKUPART_BESCHRIFTUNG = {
    manuell: 'Manuelles Backup',
    sicherungsstand: 'Automatischer Sicherungsstand',
};
/**
 * Anlass eines automatischen Sicherungsstands (§28.3).
 *
 * `manuell` steht für ein vom Administrator ausgelöstes Backup, `sicherheitsbackup` für den Stand,
 * der vor einer Wiederherstellung erzeugt wird (§28.2).
 */
export const BACKUPANLASS_WERTE = [
    'manuell',
    'sicherheitsbackup',
    'abstimmung_geschlossen',
    'abstimmung_annulliert',
    'veranstaltung_beendet',
];
export const BACKUPANLASS_BESCHRIFTUNG = {
    manuell: 'vom Administrator erzeugt',
    sicherheitsbackup: 'vor einer Wiederherstellung erzeugt',
    abstimmung_geschlossen: 'nach dem Schließen einer Abstimmung',
    abstimmung_annulliert: 'nach der Annullierung einer Abstimmung',
    veranstaltung_beendet: 'beim Ende der Veranstaltung',
};
/** Höchstzahl automatischer Sicherungsstände (§28.3). Manuelle Backups zählen nicht mit. */
export const MAX_SICHERUNGSSTAENDE = 15;
/** Mindestlänge des Backup-Passworts. Es schützt den gesamten Datenbestand. */
export const MIN_BACKUP_PASSWORT_LAENGE = 12;
//# sourceMappingURL=backup.js.map